import React from 'react';
import { StringColumn, NumericalColumn, CustomColumn } from 'baseui/data-table';
import { EMPTY_NUMBER, EMPTY_STRING } from 'commons-ui';
import dayjs from 'dayjs';
import _isEmpty from 'lodash/isEmpty';
import _startsWith from 'lodash/startsWith';
import { Button, KIND } from 'baseui/button';
import { StyledLink } from 'baseui/link';

export const COL_NAMES = {
	orderAmount: 'amount',
	transactionId: 'tid',
	zupeeUserId: 'uid',
	updatedAt: 'updatedAt',
	merchant: 'merchant',
	orderId: 'orderId',
	transactionTimestamp: 'orderCreated'
};

export const columnConfigs = [
	CustomColumn({
		title: 'Zupee User Id',
		maxWidth: 200,
		mapDataToValue: (data: any) => {
			return {
				uid: data[COL_NAMES.zupeeUserId] || EMPTY_NUMBER
			};
		},
		renderCell: (params: any) => {
			const { value } = params;

			const handleOnClick = (event: any) => {
				event.preventDefault();
				event.stopPropagation();
				if (_isEmpty(value)) return;
				const url = `/userProfile/basicDetails?uid=${value?.uid}`;
				window.open(url, '_blank');
			};

			return (
				<Button
					kind={KIND.tertiary}
					onClick={handleOnClick}
					overrides={{
						Root: {
							style: ({ $theme }) => ({
								color: $theme.colors.primaryA,
								height: '100%',
								width: '100%',
								fontSize: '12px',
								fontWeight: 'normal'
							})
						}
					}}>
					<StyledLink>{value?.uid}</StyledLink>
				</Button>
			);
		},
		textQueryFilter: (textQuery: String, data: any): boolean => {
			return _startsWith(data, `${textQuery}`);
		}
	}),
	NumericalColumn({
		title: 'Transaction Id',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.transactionId] || EMPTY_NUMBER
	}),
	NumericalColumn({
		title: 'Order Amount (₹)',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.orderAmount] || EMPTY_NUMBER
	}),
	StringColumn({
		title: 'Transaction Timestamp',
		maxWidth: 200,
		mapDataToValue: (data: any) =>
			dayjs(new Date(data[COL_NAMES.transactionTimestamp])).format('YYYY-MM-DD hh:mm A') || EMPTY_STRING
	}),
	StringColumn({
		title: 'Updated At',
		maxWidth: 200,
		mapDataToValue: (data: any) => dayjs(new Date(data[COL_NAMES.updatedAt])).format('YYYY-MM-DD hh:mm A') || EMPTY_STRING
	}),
	StringColumn({
		title: 'Order Id',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.merchant][COL_NAMES.orderId] || EMPTY_STRING
	})
];
